import { memo } from "react";
import { useAppData } from "../../hooks";
import GenericSuggestionApp from "../../meta/GenericSuggestionApp";
import { SuggestionResult } from "../../pages/SuggestionResult";
import { SuggestionSearchForm } from "../../pages/SuggestionSearchForm";
import { SuggestionAppPage } from "../../types/enums";
import { useStyles } from "./styles";

export type SuggestionAppProps = {
  appId: string;
};

export const SuggestionApp = memo(({ appId }: SuggestionAppProps) => {
  const styles = useStyles();

  const [currentPage] = useAppData<SuggestionAppPage>(appId, "currentPage");

  const component =
    currentPage === SuggestionAppPage.SEARCH_SUGGESTION
      ? SuggestionSearchForm
      : currentPage === SuggestionAppPage.SUGGESTION_RESULT
        ? SuggestionResult
        : null;

  return (
    <div className={styles.container}>
      <GenericSuggestionApp as={component} appId={appId}>
        <div>Unsupported request.</div>
      </GenericSuggestionApp>
    </div>
  );
});
